import { GamePlayerStatus } from '../../../Constants';


// Manual §3 / §3.1 cohort waits. The faction ceremony and opening ghost
// placement both land the local seat at WAITING_ID the moment it
// commits, while the rest of the cohort is still acting (other seats
// still in CHOOSE_FACTION_ID resp. OPENING_GHOST_PLACEMENT_ID). At that
// edge the generic "other Captains" line gives no hint WHICH cohort is
// blocking — the gap Michael hit in the Discord run. This extends the
// same surface that renders AIInitialLodging's "Waiting for my turn in
// the Initial Lodging Round" line (the AI-advisor message) by naming
// the open phase. Reads only per-seat status from the gameplayer_set
// the FE already holds — no new wire field. The two ceremonies never
// overlap (faction fully closes before opening ghosts starts), so the
// check order is just chronological. When the cohort closes the seat
// leaves WAITING_ID entirely, so the phase line clears on its own.
//
// COPY PLACEHOLDER — Michael's wording.
const WAIT_FOR_FACTION_COHORT_MESSAGE =
    'Waiting for the other Captains to choose their factions';
// COPY PLACEHOLDER — Michael's wording.
const WAIT_FOR_OPENING_GHOST_COHORT_MESSAGE =
    'Waiting for the other Captains to place their opening Ghosts';
const WAIT_FOR_OTHER_CAPTAINS_MESSAGE = 'Waiting for the other Captains';


function cohortHasSeatInStatus(gameController, statusId) {
    const game = gameController && gameController.game;
    const gameData = game && game.gameData;
    const seats = (gameData && gameData.gameplayer_set) || [];
    return seats.some((seat) => seat && seat.status === statusId);
}


export default function artificialWaiting(gameController, aiPackage) {
    aiPackage.success = true;
    if (cohortHasSeatInStatus(
            gameController, GamePlayerStatus.CHOOSE_FACTION_ID)) {
        aiPackage.addToMessage(WAIT_FOR_FACTION_COHORT_MESSAGE);
        return;
    }
    if (cohortHasSeatInStatus(
            gameController, GamePlayerStatus.OPENING_GHOST_PLACEMENT_ID)) {
        aiPackage.addToMessage(WAIT_FOR_OPENING_GHOST_COHORT_MESSAGE);
        return;
    }
    aiPackage.addToMessage(WAIT_FOR_OTHER_CAPTAINS_MESSAGE);
}

export function artificialWaitingForServer(gameController, aiPackage) {
    aiPackage.success = true;
    aiPackage.addToMessage('Waiting for Server');
}

export function artificialActionComplete(gameController, aiPackage) {
    aiPackage.success = true;
    aiPackage.addToMessage('Action Complete');
    // ACTION_COMPLETE_ID is a transient backend state that
    // chains finish_action -> select_next_action -> SELECT_
    // ACTION_ID. The intermediate broadcast still reaches us,
    // so this poke is mostly belt-and-suspenders for a dropped
    // second broadcast — but it MUST be wire-distinguishable
    // from the human Skip click, because the engine has
    // already advanced past ACTION_COMPLETE_ID by the time our
    // poke lands. clickAdvance() sends data.type='Advance' so
    // the engine no-ops when it's already in SELECT_ACTION_ID
    // and only advances when it's still in ACTION_COMPLETE_ID.
    if (aiPackage.execute) {
        gameController.gamePlayerApi.clickAdvance();
    }
}


export function artificialLocked(gameController, aiPackage) {
    aiPackage.success = true;
    aiPackage.addToMessage('Acknowledge Locked');
}


export function artificialExecuteAction(gameController, aiPackage) {
    aiPackage.success = true;
    aiPackage.addToMessage('Execute Action');
}
